import { SettingConst } from '@faire/web-api--source/types';

/**
 * This is part of the sign-in improvement - MFA Experience test
 * PRD: https://www.notion.so/faire/Sign-in-flow-b9efea9e78224d9f8c42dccbdb2c95d7
 * @deprecated Remove after FE/mobile usage removed
 */
export const ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024 =
  'ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024' as SettingConst<
    'ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
  >;
